import { Injectable } from '@angular/core';

@Injectable({
 providedIn: 'root'
})
export class GenericService {

 isMobile(): boolean {
   return window.innerWidth <= 1200;
 }
 
 isDesktop(): boolean {
   return !this.isMobile();
 }
}